import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Badge,
    Table,
} from "reactstrap"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import {
    setBreadcrumbItems,
    getQuotes,
    deleteQuote,
    convertQuoteToInvoice,
} from "../../store/actions"

const QuotesList = props => {
    document.title = "Gestion des Devis | CRM Entreprise"

    const breadcrumbItems = [
        { title: "Finances", link: "#" },
        { title: "Devis", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Gestion des Devis", breadcrumbItems)
        props.getQuotes()
    }, [])

    const handleDeleteQuote = quote => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce devis ?")) {
            props.deleteQuote(quote.id)
        }
    }

    const handleConvertToInvoice = quote => {
        if (window.confirm("Voulez-vous vraiment convertir ce devis en facture ?")) {
            props.convertQuoteToInvoice(quote.id, props.history)
        }
    }

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-MA', {
            style: 'currency',
            currency: 'MAD'
        }).format(amount)
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case "draft": return <Badge className="bg-light text-body border p-2 px-3">Brouillon</Badge>
            case "sent": return <Badge className="bg-info-subtle text-info p-2 px-3">Envoyé</Badge>
            case "accepted": return <Badge className="bg-success text-white p-2 px-3">Accepté</Badge>
            case "rejected": return <Badge className="bg-danger text-white p-2 px-3">Rejeté</Badge>
            case "expired": return <Badge className="bg-warning text-white p-2 px-3">Expiré</Badge>
            default: return <Badge className="bg-secondary text-white p-2 px-3">{status}</Badge>
        }
    }

    return (
        <React.Fragment>
            <div className="container-fluid">
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <div className="d-flex align-items-center justify-content-between mb-4">
                                    <CardTitle className="h4 mb-0">Historique des Devis</CardTitle>
                                    <Link to="/finance/quotes/create">
                                        <Button color="primary">
                                            <i className="mdi mdi-plus me-1"></i> Créer un Devis
                                        </Button>
                                    </Link>
                                </div>

                                <div className="table-responsive">
                                    <Table className="table table-hover table-centered align-middle table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>N° Devis</th>
                                                <th>Client</th>
                                                <th>Date</th>
                                                <th>Validité</th>
                                                <th className="text-end">Total</th>
                                                <th className="text-center">Statut</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props.quotes && props.quotes.length > 0 ? (
                                                props.quotes.map((quote, key) => (
                                                    <tr key={key}>
                                                        <td>
                                                            <Link to={`/finance/quotes/${quote.id}`} className="fw-bold text-primary">
                                                                {quote.quote_number}
                                                            </Link>
                                                        </td>
                                                        <td>
                                                            {quote.customer ? (
                                                                <div>
                                                                    <h6 className="mb-0 font-size-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                                        {quote.customer.first_name} {quote.customer.last_name}
                                                                    </h6>
                                                                    <small className="text-muted">{quote.customer.company_name}</small>
                                                                </div>
                                                            ) : "-"}
                                                        </td>
                                                        <td>{new Date(quote.quote_date).toLocaleDateString()}</td>
                                                        <td>{new Date(quote.valid_until).toLocaleDateString()}</td>
                                                        <td className="text-end fw-bold">
                                                            {formatCurrency(quote.total)}
                                                        </td>
                                                        <td className="text-center">
                                                            {getStatusBadge(quote.status)}
                                                        </td>
                                                        <td>
                                                            <div className="d-flex gap-2">
                                                                <Link to={`/finance/quotes/${quote.id}`}>
                                                                    <Button color="light" size="sm" className="text-primary">
                                                                        <i className="mdi mdi-eye font-size-14"></i>
                                                                    </Button>
                                                                </Link>
                                                                {quote.status === "draft" && (
                                                                    <Link to={`/finance/quotes/edit/${quote.id}`}>
                                                                        <Button color="light" size="sm" className="text-success">
                                                                            <i className="mdi mdi-pencil font-size-14"></i>
                                                                        </Button>
                                                                    </Link>
                                                                )}
                                                                {quote.status !== "accepted" && quote.status !== "rejected" && (
                                                                    <Button
                                                                        color="success"
                                                                        size="sm"
                                                                        className="btn-soft-success"
                                                                        onClick={() => handleConvertToInvoice(quote)}
                                                                        title="Convertir en Facture"
                                                                    >
                                                                        <i className="mdi mdi-swap-horizontal font-size-14"></i>
                                                                    </Button>
                                                                )}
                                                                <Button
                                                                    color="light"
                                                                    size="sm"
                                                                    className="text-danger"
                                                                    onClick={() => handleDeleteQuote(quote)}
                                                                >
                                                                    <i className="mdi mdi-delete font-size-14"></i>
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4 text-muted">
                                                        Aucun devis trouvé
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    quotes: state.Quotes.quotes,
    loading: state.Quotes.loading,
})

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getQuotes,
    deleteQuote,
    convertQuoteToInvoice,
})(QuotesList)
